import { fetcher } from "helpers/fetcher";

import { TGetTicketListGlobalReq, TGetTicketListGlobalRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getTicketListGlobal = async (payload: TGetTicketListGlobalReq) => {
  return await fetcher<
    TGetTicketListGlobalRes,
    TGetTicketListGlobalReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_TICKET_LIST_GLOBAL, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_TICKET_LIST.version,
    },
    data: payload.data,
  });
};

export const queryGetTicketListGlobal = async (
  payload: TGetTicketListGlobalReq
) => {
  return (await getTicketListGlobal(payload)).data;
};

queryGetTicketListGlobal._key = (payload: TGetTicketListGlobalReq) => [
  ENDPOINT.MANAGEMENT.GET_TICKET_LIST_GLOBAL.url,
  payload,
];
